import React from "react";
import { Helmet } from "react-helmet";
import "./LegalPages.css";

export const TermsAndConditions = () => {
  return (
    <>
      <Helmet>
        <title>Terms and Conditions - WTFHoroscope</title>
        <meta name="description" content="Terms and Conditions for WTFHoroscope. For entertainment purposes only." />
        <meta name="robots" content="index, follow" />
        <canonical href="https://wtfhoroscope.com/terms-and-conditions" />
      </Helmet>

      <div className="legal-page">
        <div className="container">
          <h1 className="legal-title">Terms and Conditions</h1>

          <section className="legal-section">
            <h2>1. Use of Service</h2>
            <p>
              WTFHoroscope is provided for entertainment purposes only. By using our site, you agree
              to use it in a lawful manner and not for any illegal activities.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Entertainment Only</h2>
            <p>
              <strong>IMPORTANT:</strong> WTFHoroscope horoscopes are AI-generated fiction. They are
              NOT real predictions, actual astrology, or professional advice. Do not make serious
              life decisions based on what our AI says about your future.
            </p>
            <p>
              We are not responsible for any consequences resulting from you following horoscope
              predictions. Your life decisions are your own.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. User Conduct</h2>
            <p>You agree NOT to:</p>
            <ul>
              <li>Use the site to harass, threaten, or abuse others</li>
              <li>Scrape or automate access to the site</li>
              <li>Distribute malware or malicious code</li>
              <li>Attempt to gain unauthorized access to systems</li>
              <li>Spam or engage in deceptive practices</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Intellectual Property</h2>
            <p>
              The WTFHoroscope brand, logo, design, and AI-generated horoscope content are owned by
              WTFHoroscope. You may use the horoscopes for personal use and sharing, but not for
              commercial redistribution without permission.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Third-Party Services</h2>
            <p>
              We use Google's Gemini API for generating horoscopes. We are not responsible for any
              service interruptions or data issues caused by third-party services.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Limitation of Liability</h2>
            <p>
              <strong>WTFHoroscope is provided "AS IS" without warranties.</strong> We are not liable
              for:
            </p>
            <ul>
              <li>Loss of data or service interruptions</li>
              <li>Any consequences from relying on horoscope predictions</li>
              <li>Technical issues or bugs</li>
              <li>Any indirect or consequential damages</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>7. Modifications</h2>
            <p>
              We reserve the right to modify these terms and the service itself at any time without
              notice.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Governing Law</h2>
            <p>These terms are governed by the laws of the Internet and cosmic order.</p>
            <p>
              In reality: These terms are governed by applicable internet laws where you access the
              site.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Contact</h2>
            <p>
              Questions or disputes? Contact us at:{" "}
              <a href="mailto:legal@wtfhoroscope.com">legal@wtfhoroscope.com</a>
            </p>
          </section>

          <section className="legal-section">
            <h2>Last Updated</h2>
            <p>{new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>
          </section>
        </div>
      </div>
    </>
  );
};
